// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import

export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let cType = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001566')}`, //클레임타입
			prop: 'ctypeNm',
			headerAlign: 'center',
			align: 'left',
			width: '200px',
			sortable: false
		};
		let causPartNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001141')}`, //원인부품명
			prop: 'causPartNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let causPartNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000975')}`, //원인부품번호
			prop: 'causPartNo',
			headerAlign: 'center',
			minWidth: '150px',
			sortable: false
		};

		let phmnCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001055')}`, //현상코드
			prop: 'phmnCd',
			headerAlign: 'center',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001605')}`, //현상명
			prop: 'phmnNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let causCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001029')}`, //원인코드
			prop: 'causCd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let causNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001308')}`, //원인코드명
			prop: 'causNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let speMatter = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000053')}`, //특이사항
			prop: 'speMatter',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let dtc1 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 1, //DTC1
			prop: 'dtc1',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let dtc2 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 2, //DTC2
			prop: 'dtc2',
			align: 'right',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let dtc3 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 3, //DTC3
			prop: 'dtc3',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let erpProdDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001999')}`, //HTWO 생산일
			prop: 'erpProdDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpProdMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002016')}`, //HTWO 생산월
			prop: 'erpProdMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001044')}`, //HTWO 판매일
			prop: 'erpSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001606')}`, //HTWO 판매월
			prop: 'erpSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let jvSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001010')}`, //JV 판매일
			prop: 'jvSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let jvSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001607')}`, //JV 판매월
			prop: 'jvSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let siSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001609')}`, //SI 판매일
			prop: 'siSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let siSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001610')}`, //SI 판매월
			prop: 'siSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let oemSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001611')}`, //OEM 판매일
			prop: 'oemSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let oemSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001612')}`, //OEM 판매월
			prop: 'oemSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqStrtDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001183')}`, //정비시작일
			prop: 'ceqStrtDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqStrtMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002036')}`, //정비시작월
			prop: 'ceqStrtMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqEndDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001184')}`, //정비완료일
			prop: 'ceqEndDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqEndMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001618')}`, //정비완료월
			prop: 'ceqEndMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let dcsnDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000980')}`, //확정일
			prop: 'dcsnDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let dcsnMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001297')}`, //확정월
			prop: 'dcsnMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let stokDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001615')}`, //재고일
			prop: 'stokDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let usePrd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001181')}`, //사용시간
			prop: 'usePrd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let useDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001616')}`, //사용일수
			prop: 'useDd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let milg = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000972')}`, //주행거리
			prop: 'milg',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let mtrlCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001101')}`, //자재비
			prop: 'mtrlCst',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let wags = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001102')}`, //공임비
			prop: 'wags',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let incdCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001103')}`, //附加费
			prop: 'incdCst',
			align: 'right',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let partCost = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002154')}`, //部品成本
			prop: 'partCost',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let roPartCost = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002139')}`, //保修总金额
			prop: 'roPartCost',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let totPartCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001104')}`, //总金额
			prop: 'totPartCst',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let roNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001245')}`, //RONo
			prop: 'roNo',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let saleNat = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001542')}`, //판매국가
			prop: 'saleNatNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let occuRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001050')}`, //발생지역
			prop: 'occuRegnNm',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let saleRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001019')}`, //판매지역
			prop: 'saleRegnNm',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let dtlRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001619')}`, //세부지역
			prop: 'dtlRegn',
			headerAlign: 'center',
			minWidth: '150px',
			sortable: false
		};
		let opCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001096')}`, //작업코드(opCd)명
			prop: 'opNm',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let pmcId = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001538')}`, //pmcId
			prop: 'pmcId',
			headerAlign: 'center',
			minWidth: '200px',
			sortable: false
		};
		let carScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001015')}`, //차량구분
			prop: 'carScnNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let carType = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001016')}`, //차량유형
			prop: 'carTypeNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let pacScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001017')}`, //승상구분
			prop: 'pacScnNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let carVin = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000960')}`, //车辆VIN
			prop: 'carVin',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let plntCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001540')}`, //생산공장
			prop: 'plntNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let flclSpc = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001021')}`, //연료전지사양
			prop: 'flclSpc',
			headerAlign: 'center',
			minWidth: '150px',
			sortable: false
		};
		let pwrTypeNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001018')}`, //동력유형
			prop: 'pwrTypeNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let cmpnNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001024')}`, //캠페인No
			prop: 'cmpnNo',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let cmpnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001007')}`, //캠페인명
			prop: 'cmpnNm',
			headerAlign: 'center',
			minWidth: '200px',
			sortable: false
		};

		cols.push(cType);
		cols.push(causPartNo);
		cols.push(causPartNm);
		cols.push(phmnCd);
		cols.push(phmnNm);
		cols.push(causCd);
		cols.push(causNm);
		cols.push(speMatter);
		cols.push(dtc1);
		cols.push(dtc2);
		cols.push(dtc3);
		cols.push(erpProdDd);
		cols.push(erpProdMm);
		cols.push(erpSaleDd);
		cols.push(erpSaleMm);
		cols.push(jvSaleDd);
		cols.push(jvSaleMm);
		cols.push(siSaleDd);
		cols.push(siSaleMm);
		cols.push(oemSaleDd);
		cols.push(oemSaleMm);
		cols.push(ceqStrtDd);
		cols.push(ceqStrtMm);
		cols.push(ceqEndDd);
		cols.push(ceqEndMm);
		cols.push(dcsnDd);
		cols.push(dcsnMm);
		cols.push(stokDd);
		cols.push(usePrd);
		cols.push(useDd);
		cols.push(milg);
		cols.push(mtrlCst);
		cols.push(wags);
		cols.push(incdCst);
		cols.push(partCost);
		cols.push(roPartCost);
		cols.push(totPartCst);
		cols.push(roNo);
		cols.push(saleNat);
		cols.push(occuRegn);
		cols.push(saleRegn);
		cols.push(dtlRegn);
		cols.push(opCd);
		cols.push(pmcId);
		cols.push(carScn);
		cols.push(carType);
		cols.push(pacScn);
		cols.push(carVin);
		cols.push(plntCd);
		cols.push(flclSpc);
		cols.push(pwrTypeNm);
		cols.push(cmpnNo);
		cols.push(cmpnNm);

		return cols;
	},
	excelCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let cType = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001566')}`, //클레임타입
			prop: 'ctypeNm',
			headerAlign: 'center',
			align: 'left',
			width: '200px',
			sortable: false
		};
		let causPartNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001141')}`, //원인부품명
			prop: 'causPartNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let causPartNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000975')}`, //원인부품번호(앞 5자리)
			prop: 'causPartNo',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let phmnCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001055')}`, //현상코드
			prop: 'phmnCd',
			headerAlign: 'center',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001605')}`, //현상명
			prop: 'phmnNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let causCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001029')}`, //원인코드
			prop: 'causCd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let causNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001308')}`, //원인코드명
			prop: 'causNm',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let speMatter = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000053')}`, //특이사항
			prop: 'speMatter',
			headerAlign: 'center',
			minWidth: '300px',
			sortable: false
		};
		let dtc1 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 1, //DTC1
			prop: 'dtc1',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let dtc2 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 2, //DTC2
			prop: 'dtc2',
			align: 'right',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let dtc3 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001128')}` + 3, //DTC3
			prop: 'dtc3',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let erpProdDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001999')}`, //HTWO 생산일
			prop: 'erpProdDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpProdMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002016')}`, //HTWO 생산월
			prop: 'erpProdMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001044')}`, //HTWO 판매일
			prop: 'erpSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let erpSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001606')}`, //HTWO 판매월
			prop: 'erpSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let jvSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001010')}`, //JV 판매일
			prop: 'jvSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let jvSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001607')}`, //JV 판매월
			prop: 'jvSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let siSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001609')}`, //SI 판매일
			prop: 'siSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let siSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001610')}`, //SI 판매월
			prop: 'siSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let oemSaleDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001611')}`, //OEM 판매일
			prop: 'oemSaleDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let oemSaleMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001612')}`, //OEM 판매월
			prop: 'oemSaleMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqStrtDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001183')}`, //정비시작일
			prop: 'ceqStrtDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqStrtMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002036')}`, //정비시작월
			prop: 'ceqStrtMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqEndDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001184')}`, //정비완료일
			prop: 'ceqEndDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let ceqEndMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001618')}`, //정비완료월
			prop: 'ceqEndMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let dcsnDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000980')}`, //확정일
			prop: 'dcsnDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let dcsnMm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001297')}`, //확정월
			prop: 'dcsnMm',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let stokDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001615')}`, //재고일
			prop: 'stokDd',
			align: 'center',
			minWidth: '120px',
			sortable: false
		};
		let usePrd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001181')}`, //사용시간
			prop: 'usePrd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let useDd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001616')}`, //사용일수
			prop: 'useDd',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let milg = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000972')}`, //주행거리
			prop: 'milg',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let mtrlCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001101')}`, //자재비
			prop: 'mtrlCst',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let wags = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001102')}`, //공임비
			prop: 'wags',
			headerAlign: 'center',
			align: 'right',
			minWidth: '100px',
			sortable: false
		};
		let incdCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001103')}`, //부대비
			prop: 'incdCst',
			align: 'right',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let partCost = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002154')}`, //部品成本
			prop: 'partCost',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let roPartCost = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002139')}`, //保修总金额
			prop: 'roPartCost',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let totPartCst = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001104')}`, //총금액
			prop: 'totPartCst',
			align: 'right',
			minWidth: '100px',
			headerAlign: 'center',
			sortable: false
		};
		let roNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001245')}`, //RONo
			prop: 'roNo',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let saleNat = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001542')}`, //판매국가
			prop: 'saleNatNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let occuRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001050')}`, //발생지역
			prop: 'occuRegnNm',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let saleRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001019')}`, //판매지역
			prop: 'saleRegnNm',
			headerAlign: 'center',
			minWidth: '100px',
			sortable: false
		};
		let dtlRegn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001619')}`, //세부지역
			prop: 'dtlRegn',
			headerAlign: 'center',
			minWidth: '150px',
			sortable: false
		};
		let opCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001096')}`, //작업코드(opCd)명
			prop: 'opNm',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let pmcId = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001538')}`, //pmcId
			prop: 'pmcId',
			headerAlign: 'center',
			minWidth: '200px',
			sortable: false
		};
		let carScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001015')}`, //차량구분
			prop: 'carScnNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let carType = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001016')}`, //차량유형
			prop: 'carTypeNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let pacScn = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001017')}`, //승상구분
			prop: 'pacScnNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		}; 
		let carVin = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000960')}`, //车辆VIN
			prop: 'carVin',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let plntCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001540')}`, //생산공장
			prop: 'plntNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let flclSpc = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001021')}`, //연료전지사양
			prop: 'flclSpc',
			headerAlign: 'center',
			minWidth: '150px',
			sortable: false
		};
		let pwrTypeNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001018')}`, //동력유형
			prop: 'pwrTypeNm',
			align: 'center',
			minWidth: '100px',
			sortable: false
		};
		let cmpnNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001024')}`, //캠페인No
			prop: 'cmpnNo',
			align: 'center',
			minWidth: '200px',
			sortable: false
		};
		let cmpnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001007')}`, //캠페인명
			prop: 'cmpnNm',
			headerAlign: 'center',
			minWidth: '200px',
			sortable: false
		};

		cols.push(cType);
		cols.push(causPartNo);
		cols.push(causPartNm);
		cols.push(phmnCd);
		cols.push(phmnNm);
		cols.push(causCd);
		cols.push(causNm);
		cols.push(speMatter);
		cols.push(dtc1);
		cols.push(dtc2);
		cols.push(dtc3);
		cols.push(erpProdDd);
		cols.push(erpProdMm);
		cols.push(erpSaleDd);
		cols.push(erpSaleMm);
		cols.push(jvSaleDd);
		cols.push(jvSaleMm);
		cols.push(siSaleDd);
		cols.push(siSaleMm);
		cols.push(oemSaleDd);
		cols.push(oemSaleMm);
		cols.push(ceqStrtDd);
		cols.push(ceqStrtMm);
		cols.push(ceqEndDd);
		cols.push(ceqEndMm);
		cols.push(dcsnDd);
		cols.push(dcsnMm);
		cols.push(stokDd);
		cols.push(usePrd);
		cols.push(useDd);
		cols.push(milg);
		cols.push(mtrlCst);
		cols.push(wags);
		cols.push(incdCst);
		cols.push(partCost);
		cols.push(roPartCost);
		cols.push(totPartCst);
		cols.push(roNo);
		cols.push(saleNat);
		cols.push(occuRegn);
		cols.push(saleRegn);
		cols.push(dtlRegn);
		cols.push(opCd);
		cols.push(pmcId);
		cols.push(carScn);
		cols.push(carType); 
		cols.push(pacScn);
		cols.push(carVin);
		cols.push(plntCd);
		cols.push(flclSpc);
		cols.push(pwrTypeNm);
		cols.push(cmpnNo);
		cols.push(cmpnNm);

		return cols;
	}
};
